import type { TunaPluginContentProps } from '@tunasong/plugin-lib'
import type { BandSpace } from '@tunasong/schemas'
import type { FC } from 'react'

export const ListContent: FC<TunaPluginContentProps<BandSpace>> = props => {
  const { element } = props

  if (!element.id) {
    return null
  }

  return <>Band Space content</>
}

export default ListContent
